<template>
  <click-to-edit
    v-model="scope.row.scale.deadline"
    type="date-picker"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.deadline')"
    placeholder="Внесите целевой срок"
    @input="saveElementPropChange(scope.row, 'scale', {deadline:$event})"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
export default {
  name: 'element-deadline-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
